import type { App as VueApp, Plugin } from "vue";
import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";
import InfoRequest from "@Scripts/Components/InfoRequest/InfoRequest.vue";
import Locator from "@Scripts/Components/Locator/Locator.vue";

import ExpandingTable from "@Scripts/Directives/ExpandingTable/ExpandingTable";

const AppConfig : Plugin = {
    install(app: VueApp) {
        app.component("app-cookietoast", CookieToast);
        app.component("app-inforequest", InfoRequest);
        app.component("app-locator", Locator);

        app.directive("expanding-table", ExpandingTable);
    }
};

export default AppConfig;